export const BASE_ROUTE = '/';
export const QUICK_INVITE_MODAL_ROUTE = '/quick-invite';
export const DATA_SYNC_MODAL_ROUTE = '/data-modal';
export const CHANGE_DEFAULT_HOMEPAGE_ROUTE = '/change-homepage';
export const TRIAL_ACTIVATION_SUCCESS_MODAL_ROUTE = '/trial-activation-success';